import type { OwaDate, GlobalCalendarLocale } from 'owa-datetime';
import { localizedFormatter } from './localizedFormatter';

/**
 * Gets a short version of the user's date format, with just day and month.
 */
export function getShortUserDateFormat(dateFormat: string): string {
    const matches = dateFormat.match(/((M+[^M]*d+)|(d+[^d]*M+))(?:.$)?/);
    return matches ? matches[0] : dateFormat;
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getShortUserDateFormat);
export default defaultExport;
